module.exports = "<p>generalsetting works!</p>\r\n"